import { Lightning } from '@phosphor-icons/react';
import { Text } from '@typedream/ui';
import classNames from 'classnames';
import Link from 'next/link';
import { useMemo } from 'react';
import { MenuItemProps } from './types';

export function MenuItem({ href, menu, isActive, onClick = () => null }: MenuItemProps) {
  const Wrapper = useMemo(() => (href ? Link : 'button'), [href]);

  return (
    <Wrapper
      href={href}
      className={classNames(
        'flex items-center gap-1.5 p-1.5 border-0 rounded-lg text-primary-soft hover:text-primary-soft cursor-pointer',
        {
          'bg-background-highlight': isActive,
          'bg-transparent hover:bg-background-highlight': !isActive,
        }
      )}
      onClick={() => onClick(menu)}
    >
      {menu?.icon}
      <Text size="xs" weight="medium" className="flex-1 text-left">
        {menu?.label}
      </Text>
      {menu?.isUpgradeBadge && <Lightning size={14} weight="fill" color="var(--primary-400)" />}
    </Wrapper>
  );
}
